Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    COLORS = _STYLES$useStyles.COLORS;
  var maxWidth = _styles.STYLES.grid.maxContentWidth;
  var spacerWidth = spacing.page.padding.paddingRight;
  var container = {
    width: '100%'
  };
  var indicatorContainer = {
    marginTop: spacing.l,
    marginBottom: spacing.l,
    paddingLeft: spacing.page.padding.paddingLeft,
    paddingRight: spacing.page.padding.paddingRight,
    alignSelf: 'center',
    width: '100%',
    maxWidth: maxWidth
  };
  var indicatorBar = {
    backgroundColor: COLORS.whisper,
    borderRadius: (0, _styles.getREM)(0.3125),
    height: (0, _styles.getREM)(0.625)
  };
  var indicator = {
    backgroundColor: COLORS.aubergine,
    borderRadius: (0, _styles.getREM)(0.3125),
    height: (0, _styles.getREM)(0.625)
  };
  var spacer = {
    width: spacerWidth,
    height: 1
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    indicatorContainer: indicatorContainer,
    indicatorBar: indicatorBar,
    indicator: indicator,
    spacer: spacer
  });
  return {
    styles: styles,
    maxWidth: maxWidth,
    spacerWidth: spacerWidth
  };
};